var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDialog = function SvgDialog(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    d: "M10 2.667v4.666H3.447l-.78.78V2.667zm.667-1.334H2A.667.667 0 0 0 1.333 2v9.333L4 8.667h6.667A.667.667 0 0 0 11.334 8V2a.666.666 0 0 0-.667-.667M14 4h-1.333v6H4v1.333a.667.667 0 0 0 .667.667H12l2.667 2.667v-10A.667.667 0 0 0 14 4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDialog);
export { ForwardRef as ReactComponent };